import angular from 'angular';
import KlarnaPaymentService from "../klarna/klarna-payment.service";

let klarna = angular
    .module('klarna', [])
    .service('KlarnaPaymentService', KlarnaPaymentService);

export default klarna;
